import { Divider, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { theme } from '../../theme';
import { IntegerTextField } from '../components/textFields/IntegerTextField';
import { useAnchorElement } from '../hooks/useAnchorElement';
import { FilterButton } from './FilterButton';
import { FilterMenu } from './FilterMenu';
import { useLocalization } from 'localization/useLocalization';

interface IMinMax {
	min: number | undefined;
	max: number | undefined;
}

interface IProps {
	min: number;
	max?: number;
	selected: IMinMax;
	setSelected: (value: IMinMax) => void;
	label: string;
	icon: React.ReactNode;
}

export const NumberRangeFilterComponent = ({ min, max, selected, setSelected, label, icon }: IProps) => {
	const strings = useLocalization();
	const [value, setValue] = useState<IMinMax>(selected);
	const [anchor, open, close] = useAnchorElement();

	useEffect(() => {
		setValue(selected);
	}, [selected]);

	const handleClose = () => {
		if (value !== selected) {
			setSelected(value);
		}
		close();
	};

	return (
		<>
			<FilterButton
				badgeContent={selected.min === undefined && selected.max === undefined ? 0 : 1}
				label={label}
				handleOpen={open}
				icon={icon}
			/>
			<FilterMenu
				anchorEl={anchor}
				open={Boolean(anchor)}
				onClose={handleClose}>
				<div
					className='df-col'
					style={{ padding: theme.spacing(2) }}>
					<Typography align='center'>{strings.selectMinMax}</Typography>
					<Typography
						variant='caption'
						align='center'>{`min: ${min} - max: ${max}`}</Typography>
					<Divider />
					<div
						className='df-row-ac jc-sb'
						style={{ marginTop: theme.spacing(2) }}>
						<IntegerTextField
							value={value.min}
							onChange={val => setValue({ ...value, min: val })}
							label='Min'
							style={{ marginRight: theme.spacing(1.5) }}
						/>
						<IntegerTextField
							value={value.max}
							onChange={val => setValue({ ...value, max: val })}
							label='Max'
						/>
					</div>
				</div>
			</FilterMenu>
		</>
	);
};
